import gql from "/vendor/graphql-tag";
import handle from "/lib/exceptionHandler";

const fragment = gql`
  fragment DeleteHandlerMutation_handler on Handler {
    deleted @client
  }
`;

const mutation = gql`
  mutation DeleteHandlerMutation($input: DeleteRecordInput!) {
    deleteHandler(input: $input) {
      deletedId
    }
  }
`;

export default (client, { id }) =>
  client.mutate({
    mutation,
    variables: {
      input: { id },
    },
    update: (cache) => {
      try {
        const handler = cache.readFragment({ fragment, id });
        const data = { ...handler, deleted: true };
        cache.writeFragment({ fragment, id, data });
      } catch (error) {
        handle(error);
      }
    },
    optimisticResponse: {
      deleteHandler: {
        deletedId: id,
        __typename: "DeleteRecordPayload",
      },
      __typename: "Mutation",
    },
  });
